export default __webpack_public_path__ + "static/Template-a1be442492289b97743b2b1d5600cc09.png";